import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg"

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 text-gray-700 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,textarea {
  ${tw`w-full bg-transparent text-base font-medium tracking-wide border-b-2 py-2 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input`text-gray-700
  bg-transparent`;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24`
const Heading = tw.h4`font-bold text-2xl md:text-2xl lg:text-2xl xl:text-4xl text-gray-900 leading-tight text-center border-4 border-primary-100 pb-3 p-4 rounded-lg`;


const Toast = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 320px;
  max-width: 90%;
  padding: 18px 22px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  z-index: 99999;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  background-color: ${({ type }) =>
    type === "success" ? "rgba(100,21,255,var(--tw-text-opacity))" : "#dc2626"};

  animation: scaleIn 0.35s ease, fadeOut 0.4s ease 2.6s;

  @keyframes scaleIn {
    from {
      transform: translate(-50%, -50%) scale(0.85);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    to {
      opacity: 0;
    }
  }
`;

const CloseBtn = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;

  &:hover {
    opacity: 0.8;
  }
`;
export default () => {

  const [popup, setPopup] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPopup("");

    const formData = new FormData(e.target);

    try {
      const res = await axios.post(
        "https://vizual-ads.quetzalsads.com/mail.php",
        formData
      );

      if (res.data.status === "success") {
        setPopup("success");
        e.target.reset();

        // ✅ Auto-close after 3 seconds
        setTimeout(() => setPopup(""), 3000);
      } else {
        setPopup("error");
      }
    } catch (error) {
      setPopup("error");
    }
  };

  return (
    <Container>
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl">
            <Heading>
              Request for a Quote
              {/* <br />or<br />
              <span tw="text-primary-500">
                <a href="mailto:rb@vizualads.com">rb@vizualads.com</a>
              </span> */}
            </Heading>

            {/* ================= FORM ================= */}
            <form onSubmit={handleSubmit}>
              <InputContainer>
                <Label>Your Name</Label>
                <Input
                  name="name"
                  placeholder="E.g. John Doe"
                  required
                />
              </InputContainer>
              <TwoColumn>
                <Column>
                  <InputContainer>
                    <Label>Your Email</Label>
                    <Input
                      name="email"
                      type="email"
                      placeholder="E.g. john@mail.com"
                      required
                    />
                  </InputContainer>

                  <InputContainer>
                    <Label>Your Phone</Label>
                    <Input
                      name="phone"
                      placeholder="E.g. +1 (612) 205-9287"
                    />
                  </InputContainer>
                </Column>

                <Column>
                  <InputContainer>
                    <Label>Your Zip Code</Label>
                    <Input name="zip" placeholder="E.g. 12345" />
                  </InputContainer>
                  <InputContainer>
                    <Label>Attach PDFs (Max 10MB)</Label>
                    <Input type="file" name="attachments[]" placeholder="*.pdf only" accept="application/pdf" multiple />
                  </InputContainer>

                </Column>
              </TwoColumn>
              <InputContainer>
                <Label>Drive Link(* If file size more than 10MB) </Label>
                <Input
                  name="fileLink"
                  placeholder="E.g. https://drive.google.com/file/d/..."
                />
              </InputContainer>
              <InputContainer tw="flex-1">
                <Label>Your Message</Label>
                <TextArea
                  name="message"
                  placeholder="E.g. Details about your event"
                  required
                />
              </InputContainer>
              <SubmitButton type="submit">Submit</SubmitButton>
            </form>

            {/* ================= CENTER TOAST ================= */}
            {popup && (
              <Toast type={popup}>
                <span>
                  {popup === "success"
                    ? "✅ Mail sent successfully"
                    : "❌ Mail sending failed"}
                </span>
                <CloseBtn onClick={() => setPopup("")}>✖</CloseBtn>
              </Toast>
            )}
          </div>

          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};
